<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca7"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="reconciliationList_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="reconciliationList_export_button" @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      show-footer
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="documentNumber"
          title="单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.documentNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperDeliveryFee"
          title="账期运费"
          width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.shipperDeliveryFeeMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('shipperDeliveryFeeMin')"
            />
            <el-input
              v-model="listQuery.shipperDeliveryFeeMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('shipperDeliveryFeeMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="补扣金额33"
          width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.payAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('payAmountMin')"
            />
            <el-input
              v-model="listQuery.payAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('payAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="billType"
          title="对账单类型"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ billTypeMap[row.billType] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.billType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v, k) in billTypeMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ auditMap[row.authStatus] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v, k) in auditMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authName"
          title="审核人"
          width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.authName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="100">
        <template v-slot="{ row }">
          <el-tooltip
            v-if="reconciliationList_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="800"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import compDetail from "./components/detail.vue";
import { collectionPost } from "@/api/category";
import { isNumber } from "@/utils/validate.js";
export default {
  name: "CollectionAccountCheckList",
  components: {
    compDetail
  },
  data() {
    return {
      exportObj: {
        exportUrl:
          "/ntocc-tms-api/collectionAccountCheck/exportCollectionAccountCheck", //导出接口
        name: "对账列表"
      },
      auditMap: { "0": "未审核", "1": "审核中", "2": "已拒绝", "3": "已通过" },
      billTypeMap: { "0": "托运人对账", "1": "上游客户对账", "3": "保费对账" },
      processType: "7",
      processApi: "collectionAccountCheck",
      modelAuditFlag: false,
      modelDetailFlag: false,
      loading: false,
      reconciliationList_search_button: false, //查询
      reconciliationList_export_button: false, //导出
      reconciliationList_detail_button: false, //详情
      tableData: [],
      listQuery: {
        documentNumber: "",
        shipmentName: "",
        authStatus: "",
        billType: "",
        shipperDeliveryFeeMin: "",
        shipperDeliveryFeeMax: "",
        payAmountMin: "",
        payAmountMax: "",
        authName: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        collectionAccountionType: 1
      },
      sumObject: {},
      //机构信息
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
    this.reconciliationList_search_button = getLimit(
      "reconciliationList_search_button"
    );
    this.reconciliationList_export_button = getLimit(
      "reconciliationList_export_button"
    );
    this.reconciliationList_detail_button = getLimit(
      "reconciliationList_detail_button"
    );
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        collectionPost(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "audit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 审核方法
    funcAudit(code, step) {
      this.$refs.auditRef.getInfo(code, step);
      this.modelAuditFlag = true;
    },
    // 审核组件的父方法
    fatherAudit() {
      this.modelAuditFlag = false;
      this.findList();
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "payAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
<style lang="scss" scoped></style>
